import datos from "src/services/datos";

const comprobantes = new datos("comprobantes");
export const setComprobantesDigitalizacionesData = async (params) => {
  let dataDigitalizacion = {digitalizaciones: params.digitalizaciones_contenidos , contenido: params.contenido}
  const response = await comprobantes.setComprobantesDigitalizaciones(dataDigitalizacion);
  return response;
};
